const networks = {
  public: 'public',
  test: 'test',
  local: 'local',
  future: 'future',
}

const hostnameToNetworkType = (hostname) => {
  if (hostname === 'explorel.elar.ai' || hostname === 'publicnet.local') {
    return networks.public
  } else if (
    hostname === 'testnet.explorel.elar.ai' ||
    hostname === 'testnet.local'
  ) {
    return networks.test
  } else if (
    hostname === 'futurenet.explorel.elar.ai' ||
    hostname === 'futurenet.local'
  ) {
    return networks.future
  } else return networks.local
}

export {networks as default, hostnameToNetworkType}



// WEBPACK FOOTER //
// ./src/lib/stellar/networks.js